import { Toaster } from 'sonner'

interface AgencyLayoutProps {
  children: React.ReactNode
}

/**
 * 代理店ポータル用のレイアウト。
 * 内部ヘッダ・サイドバーは Dashboard 等の各ページに含めるため、
 * ここでは Toaster だけを配り、ページ自体は素のまま描画する。
 */
export function AgencyLayout({ children }: AgencyLayoutProps) {
  return (
    <>
      {children}
      <Toaster position="top-right" richColors closeButton />
    </>
  )
}
